import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitVaccinationDetails = ({
  vaccinations,
  vaccinationRef,
  handleFileDownload,
}) => {
  if (!Array.isArray(vaccinations) || vaccinations.length === 0) {
    return null;
  }

  const formatDateWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    const value = String(date);
    const datePart = value.substring(0, 10);
    const timePart = value.substring(11, 16);

    if (!datePart) {
      return '-';
    }

    if (!timePart || timePart === '00:00') {
      return datePart;
    }

    return `${datePart} ${timePart}`;
  };

  const formatDateOnlyWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    return String(date).substring(0, 10);
  };

  return (
    <div ref={vaccinationRef} className="mt-3">
      {vaccinations.map((vaccination, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Skiepai</Heading>
          </CardHeader>

          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {formatDateWithoutConversion(
                  vaccination.occurrenceDateTime,
                )}
              </span>
            </div>

            {vaccination.practitioner && (
              <div>
                <span>Gydytojas: </span>
                <span>
                  {vaccination.practitioner.qualification} -{' '}
                  {vaccination.practitioner.name}{' '}
                  {vaccination.practitioner.surname}
                </span>
              </div>
            )}

            {vaccination.diagnosis && (
              <div>
                <span>Pagrindinė diagnozė: </span>
                <span>{vaccination.targetDisease}</span>
              </div>
            )}

            {vaccination.e063Status?.toString().toLowerCase() !==
              'pasirasytas' && (
              <div className="text-red-600 font-medium">LAUKIAMA REZULTATŲ</div>
            )}

            {vaccination.doseQuantity && (
              <div>
                <span>Dozė: </span>
                <span>{vaccination.doseQuantity}</span>
              </div>
            )}

            {vaccination.vaccineCode && (
              <div>
                <span>Serijos numeris: </span>
                <span>{vaccination.vaccineCode}</span>
              </div>
            )}

            {vaccination.name && (
              <div>
                <span>Vakcinos pavadinimas: </span>
                <span>{vaccination.name}</span>
              </div>
            )}

            {vaccination.manufacturer && (
              <div>
                <span>Gamintojas: </span>
                <span>{vaccination.manufacturer}</span>
              </div>
            )}

            {vaccination.nextImmunizationDate && (
              <div>
                <span>Kitos vakcinos data: </span>
                <span>
                  {formatDateWithoutConversion(
                    vaccination.nextImmunizationDate,
                  )}
                </span>
              </div>
            )}

            {vaccination.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${vaccination.vaccine || vaccination.name} ${formatDateOnlyWithoutConversion(
                      vaccination.occurrenceDateTime,
                    )}`;

                    handleFileDownload(
                      'Vaccination',
                      fileName,
                      vaccination.file.type,
                      vaccination.file.guid,
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>

          <CardFooter />
        </Card>
      ))}
    </div>
  );
};